module.exports = __webpack_public_path__ + "img/stick_activites_baignade.344b1011.svg";